import { Box, Drawer, Grid } from "@mui/material"
import { ReportFolio } from "../../../../components/repotFolios"
import { ReportFolioByAnswerProps } from "./typee"
import { useReportFolioByAnswer } from "./reportFolioByAnswerStyles"
import { useRefs } from "../../../../../../hooks/useReactHookModified"
import { useEvidencesType } from "../../../../../../hooks/evidences/useEvidences"
import { useEffect } from "react"
import { ArrowBack } from "../../../../../../components/arrowBack"
import { ReportFolioRef } from "../../../../components/repotFolios/types"
import { useTranslation } from "react-i18next"

const ReportFolioByAnswer = (props: ReportFolioByAnswerProps) => {
    const styles = useReportFolioByAnswer()
    const { t } = useTranslation()
    const { refsByKey, addRef } = useRefs<ReportFolioRef>()
    const evidencesFolios = useEvidencesType({ defaultValues: props.data?.evidencesData })
    const saveData = () => {
        const getData = refsByKey['reportFolio']?.getData
        if (getData) {
            const body = refsByKey['reportFolio']?.getData()
            props.arrowBack({
                evidence: evidencesFolios,
                body,
            })
            evidencesFolios.cleanAll()
        }
    }
    useEffect(() => {
        // refsByKey['folioLimit']?.validate()
        // refsByKey['folioReject']?.validate()
    }, [refsByKey['folioLimit'], refsByKey['folioReject']])
    return (
        <Drawer open={!!props.id} anchor="right">
            <Box sx={styles.containerReportFolio}>

                <ArrowBack
                    arrowProps={{
                        onClick: props.cancel,
                        sx: {
                            padding: '10px 20px 10px 0px',
                        }
                    }}
                    label={t('general.returnQuestionnaireConfig')}
                    boxProps={{
                        sx: {
                            marginLeft: '-20px'
                        }
                    }}
                />
                <ReportFolio
                    ref={(element) => addRef({ element, name: 'reportFolio' })}
                    evidencesCount={evidencesFolios.evidencesCount}
                    limitFoliosProps={{
                        removeForm: true,
                        styleSx: { width: '100%' },
                        parentWrapper: ({ children }) => <Grid spacing={2} alignItems='center' container children={children} />,
                    }}
                    defaultData={props.default}
                    rejectsFolioProps={{
                        removeForm: true,
                        parentWrapper: ({ children }) => <Grid spacing={2} alignItems='center' container children={children} />,
                    }}
                    openMenu={({ anchor }) => {
                        evidencesFolios.openMenu({ anchor: anchor, defaultValues: props.data?.evidencesData })
                    }}
                    save={saveData}
                    removeFolios={props.cancel}
                    baseMenuProps={{
                        anchorEl: evidencesFolios.anchorEl,
                        setAnchorEl: () => { evidencesFolios.closeMenu() },
                        menuItems: evidencesFolios.menu,
                        click: (item) => { evidencesFolios.clickOption({ item }) },
                    }}
                    drawerEvidencesProps={{
                        refsByKey: evidencesFolios.refsByKey,
                        defaultValues: evidencesFolios?.evidencesData,
                        open: evidencesFolios.openEvidenceDrawer,
                        setRef: evidencesFolios.setRef,
                        save: (data) => {
                            evidencesFolios.saveEvidence(data || [])
                        },
                        cancel: evidencesFolios.cancelEvidence,
                    }}
                />
            </Box>
        </Drawer>
    )
}

export { ReportFolioByAnswer }